import { graphql } from "../gql";

export const getCasesConnectionQueryDoc = graphql(`
  query getCasesConnection($args: CasesArgs) {
    casesConnection(args: $args) {
      __typename
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      nodes {
        ...CaseFragment
        queue {
          ...AskAutodorQueueFragment
        }
      }
      edges {
        cursor
        node {
          ...CaseFragment
          queue {
            ...AskAutodorQueueFragment
          }
        }
      }
    }
  }
`);
